import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  downloadProductPdf,
  printProductPdf,
} from 'b2b-apps/shop/product/redux/productPdf/actionCreators';

type UseProductPdfActionsReturnType = {
  printPdf: (sku: string, content: string) => void;
  downloadPdf: (sku: string, content: string) => void;
};

const useProductPdfActions = (): UseProductPdfActionsReturnType => {
  const dispatch = useDispatch();

  return {
    printPdf: useCallback(
      (sku: string, content: string) => {
        dispatch(printProductPdf(sku, content));
      },
      [dispatch],
    ),
    downloadPdf: useCallback(
      (sku: string, content: string) => {
        dispatch(downloadProductPdf(sku, content));
      },
      [dispatch],
    ),
  };
};

export type { UseProductPdfActionsReturnType };
export { useProductPdfActions };
